import { useFormContext } from "react-hook-form";
import type { SystemSettingsFormValues } from "src/admin/administration/tabs/SystemTab/types.ts";
import { Flex } from "src/components/Flex.tsx";

import { ResourceEnum } from "src/constants/constants.ts";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { SelectField } from "src/components/Form/fields/SelectField.tsx";

export const TaxAndBookingSettings = () => {
  const { t } = useTranslation(TranslationNamespaceEnum.Administration);
  const form = useFormContext<SystemSettingsFormValues>();

  return (
    <Flex flexDirection={"column"} gap={"15px"}>
      <SelectField
        name={"delivery_methods_that_require_tax_calculation"}
        control={form.control}
        isMultiple
        style={{
          maxWidth: 480,
        }}
        label={t("system.form.fields.delivery_method_tax.label")}
        serverOptions={{
          resource: ResourceEnum.DeliveryMethod,
        }}
      />

      {/*List of countries (EU) (vat status)*/}
      <SelectField
        name={"countries_vat_status"}
        control={form.control}
        isMultiple
        style={{
          maxWidth: 480,
        }}
        label={t("system.form.fields.countries_tax.label")}
        serverOptions={{
          resource: ResourceEnum.Country,
          labelProp: "name",
          // Will ever Ukraine be in this list?
        }}
      />
    </Flex>
  );
};
